import { render, staticRenderFns } from "./FilialEdit.vue?vue&type=template&id=3886d704&scoped=true"
import script from "./FilialEdit.vue?vue&type=script&lang=js"
export * from "./FilialEdit.vue?vue&type=script&lang=js"
import style0 from "./FilialEdit.vue?vue&type=style&index=0&id=3886d704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886d704",
  null
  
)

export default component.exports